import { Colors, FlexBox, SadFaceIcon, Text } from '@helloself/hello-self-ui';
import React from 'react';

export type SubmitErrorProps = {
    errorMessage: string;
};

export function SubmitError({ errorMessage }: SubmitErrorProps) {
    return (
        <FlexBox alignSelf="stretch" alignItems="center" padding="12px" gap="12px">
            <SadFaceIcon />
            <Text fontWeight="600" textColor={Colors.pink} textSize="small" margin="6px 0">
                Error: {errorMessage}
            </Text>
        </FlexBox>
    );
}
